(function () {
  'use strict';

  var menuButton = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', function () {
      var isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      mobileNav.hidden = isOpen;
    });
  }

  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerBody = drawer && drawer.querySelector('[data-cart-items]');
  var cartEndpoint = drawer && drawer.getAttribute('data-cart-endpoint');
  var cartChangeUrl = drawer && drawer.getAttribute('data-cart-change-url');
  var comparePrices = {};
  if (drawer) {
    (drawer.getAttribute('data-compare-prices') || '').split(',').forEach(function (entry) {
      var pair = entry.trim().split(':');
      if (pair.length === 2 && pair[0] && pair[1]) comparePrices[pair[0]] = Number(pair[1]) || 0;
    });
  }
  var timerInterval = null;
  var locale = document.documentElement.lang || 'en-US';
  var currency = document.querySelector('[data-product-section]')?.getAttribute('data-currency') || 'USD';
  var formatMoney = function (cents) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
  };
  var escapeHTML = function (value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  };
  var bundleQuantityMultiplier = function (item) {
    var variantTitle = String(item && item.variant_title || '');
    return /(?:^|\D)4(?:\D|$)/.test(variantTitle) ? 2 : 1;
  };
  var formatTimer = function (seconds) {
    var safeSeconds = Math.max(0, Number(seconds) || 0);
    var minutes = Math.floor(safeSeconds / 60);
    var remainder = safeSeconds % 60;
    return String(minutes).padStart(2, '0') + ':' + String(remainder).padStart(2, '0');
  };
  var startCartTimer = function () {
    if (!drawer) return;
    if (timerInterval) window.clearInterval(timerInterval);
    var timer = drawer.querySelector('[data-cart-timer]');
    var seconds = Number(drawer.getAttribute('data-timer-seconds')) || 294;
    if (!timer) return;
    timer.textContent = formatTimer(seconds);
    timerInterval = window.setInterval(function () {
      seconds = Math.max(0, seconds - 1);
      timer.textContent = formatTimer(seconds);
      if (seconds === 0) {
        window.clearInterval(timerInterval);
        timerInterval = null;
      }
    }, 1000);
  };
  var setDrawerOpen = function (open) {
    if (!drawer) return;
    drawer.hidden = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('cart-drawer-open', open);
    if (open) {
      startCartTimer();
      var closeButton = drawer.querySelector('[data-cart-close]');
      if (closeButton) closeButton.focus();
    } else if (timerInterval) {
      window.clearInterval(timerInterval);
      timerInterval = null;
    }
  };
  var updateCartCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (element) { element.textContent = count; });
    document.querySelectorAll('[data-cart-item-count]').forEach(function (element) {
      element.textContent = count + (count === 1 ? ' item' : ' items');
    });
  };
  var renderCart = function (cart) {
    if (!drawer || !drawerBody) return;
    updateCartCount(cart.item_count);
    var savings = cart.items.reduce(function (total, item) {
      var compareAt = comparePrices[String(item.variant_id)] || 0;
      var compareLine = compareAt > (Number(item.price) || 0) ? compareAt * (Number(item.quantity) || 0) : (Number(item.original_line_price) || 0);
      return total + Math.max(0, compareLine - (Number(item.final_line_price) || 0));
    }, 0);
    if (!cart.item_count) {
      drawerBody.innerHTML = '<div class="cart-drawer__empty" data-cart-empty><p>Your cart is ready for its first Lemvi.</p><button class="button button--dark" type="button" data-cart-close>Keep browsing</button></div>';
    } else {
      drawerBody.innerHTML = cart.items.map(function (item) {
        var image = item.image ? '<img src="' + escapeHTML(item.image) + '&width=180" alt="' + escapeHTML(item.product_title) + '" loading="lazy">' : '';
        var compareAt = comparePrices[String(item.variant_id)] || 0;
        var compareLine = compareAt > (Number(item.price) || 0) ? compareAt * (Number(item.quantity) || 0) : (Number(item.original_line_price) || 0);
        var itemSavings = Math.max(0, compareLine - (Number(item.final_line_price) || 0));
        var original = itemSavings > 0 ? '<del data-line-original>' + formatMoney(compareLine) + '</del>' : '';
        var savingsText = itemSavings > 0 ? '<span data-line-savings>(Save ' + formatMoney(itemSavings) + ')</span>' : '';
        var quantityMultiplier = bundleQuantityMultiplier(item);
        var displayedQuantity = (Number(item.quantity) || 0) * quantityMultiplier;
        return '<article class="cart-drawer__line" data-cart-line data-line-key="' + escapeHTML(item.key) + '" data-line-quantity="' + item.quantity + '" data-quantity-multiplier="' + quantityMultiplier + '"><div class="cart-drawer__line-image">' + image + '</div><div class="cart-drawer__line-copy"><strong>' + escapeHTML(item.product_title) + '</strong><div class="cart-drawer__qty" aria-label="Quantity"><button type="button" data-cart-quantity data-quantity-change="-1" aria-label="Decrease quantity">−</button><span data-cart-quantity-value>' + displayedQuantity + '</span><button type="button" data-cart-quantity data-quantity-change="1" aria-label="Increase quantity">+</button></div></div><button class="cart-drawer__remove" type="button" data-cart-remove data-line-key="' + escapeHTML(item.key) + '" aria-label="Remove ' + escapeHTML(item.product_title) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M10 4h4l1 3H9l1-3ZM8 10v7M12 10v7M16 10v7M6 7l1 13h10l1-13"></path></svg></button><div class="cart-drawer__line-price">' + original + '<strong data-line-final>' + formatMoney(item.final_line_price) + '</strong>' + savingsText + '</div></article>';
      }).join('');
    }
    var savingsNode = drawer.querySelector('[data-cart-savings]');
    if (savingsNode) savingsNode.textContent = '-' + formatMoney(savings);
    var orderTotal = drawer.querySelector('[data-cart-order-total]');
    if (orderTotal) orderTotal.textContent = formatMoney(cart.total_price);
    var checkout = drawer.querySelector('[data-cart-checkout]');
    if (checkout) {
      checkout.setAttribute('aria-disabled', cart.item_count ? 'false' : 'true');
      checkout.classList.toggle('is-disabled', !cart.item_count);
    }
  };
  var refreshCart = function (openAfter) {
    if (!cartEndpoint) return Promise.resolve();
    return fetch(cartEndpoint, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { if (!response.ok) throw new Error('Cart refresh failed'); return response.json(); })
      .then(function (cart) { renderCart(cart); if (openAfter) setDrawerOpen(true); return cart; });
  };

  if (drawer) {
    drawer.addEventListener('click', function (event) {
      var closeTarget = event.target.closest('[data-cart-close]');
      if (closeTarget) { event.preventDefault(); setDrawerOpen(false); return; }
      var checkoutTarget = event.target.closest('[data-cart-checkout]');
      if (checkoutTarget && checkoutTarget.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      var removeTarget = event.target.closest('[data-cart-remove]');
      if (removeTarget && cartChangeUrl) {
        event.preventDefault();
        removeTarget.disabled = true;
        fetch(cartChangeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: removeTarget.getAttribute('data-line-key'), quantity: 0 }) })
          .then(function (response) { if (!response.ok) throw new Error('Cart update failed'); return response.json(); })
          .then(function (cart) { renderCart(cart); })
          .catch(function () { removeTarget.disabled = false; });
        return;
      }
      var quantityTarget = event.target.closest('[data-cart-quantity]');
      if (quantityTarget && cartChangeUrl) {
        event.preventDefault();
        var line = quantityTarget.closest('[data-cart-line]');
        var lineKey = line && line.getAttribute('data-line-key');
        var currentQuantity = line && Number(line.getAttribute('data-line-quantity'));
        var delta = Number(quantityTarget.getAttribute('data-quantity-change')) || 0;
        var nextQuantity = Math.max(0, (currentQuantity || 0) + delta);
        if (!lineKey || nextQuantity === currentQuantity) return;
        line.querySelectorAll('button').forEach(function (button) { button.disabled = true; });
        fetch(cartChangeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: lineKey, quantity: nextQuantity }) })
          .then(function (response) { if (!response.ok) throw new Error('Cart update failed'); return response.json(); })
          .then(function (cart) { renderCart(cart); })
          .catch(function () { line.querySelectorAll('button').forEach(function (button) { button.disabled = false; }); });
      }
    });
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (!drawer) return;
      event.preventDefault();
      refreshCart(true);
    });
  });

  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('.product-form');
    var select = section.querySelector('[data-variant-select]');
    var price = section.querySelector('[data-price]');
    var compare = section.querySelector('[data-compare]');
    var button = section.querySelector('[data-add-to-cart]');
    var sticky = section.querySelector('[data-mobile-sticky-submit]');
    var stickyPack = section.querySelector('[data-sticky-pack]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickyCompare = section.querySelector('[data-sticky-compare]');
    if (!select) return;

    var sectionCurrency = section.getAttribute('data-currency') || currency;
    var sectionFormatMoney = function (cents) {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: sectionCurrency }).format((Number(cents) || 0) / 100);
    };
    var cards = section.querySelectorAll('[data-variant-card]');
    var syncCards = function () {
      cards.forEach(function (card) {
        var selected = card.getAttribute('data-variant-id') === select.value;
        card.classList.toggle('is-selected', selected);
        var radio = card.querySelector('input[type="radio"]');
        if (radio) radio.checked = selected;
      });
    };
    var updateVariant = function () {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var cents = parseFloat(option.getAttribute('data-price-cents') || '0');
      var compareCents = parseFloat(option.getAttribute('data-compare-cents') || '0');
      if (price) price.textContent = sectionFormatMoney(cents);
      if (compare) {
        compare.textContent = compareCents > cents ? sectionFormatMoney(compareCents) : '';
        compare.hidden = !(compareCents > cents);
      }
      if (stickyPack) stickyPack.textContent = option.getAttribute('data-pack-label') || option.textContent.split(' · ')[0];
      if (stickyPrice) stickyPrice.textContent = sectionFormatMoney(cents);
      if (stickyCompare) {
        stickyCompare.textContent = compareCents > cents ? sectionFormatMoney(compareCents) : '';
        stickyCompare.hidden = !(compareCents > cents);
      }
      if (button) button.disabled = option.disabled;
      if (sticky) sticky.disabled = option.disabled;
      syncCards();
    };
    select.addEventListener('change', updateVariant);
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var id = card.getAttribute('data-variant-id');
        if (!id) return;
        select.value = id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    updateVariant();

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!drawer || !cartEndpoint) return;
        event.preventDefault();
        var submitButton = button || form.querySelector('button[type="submit"]');
        if (submitButton) { submitButton.disabled = true; submitButton.setAttribute('aria-busy', 'true'); }
        fetch(form.getAttribute('action') || section.getAttribute('data-cart-add-url') || '/cart/add', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (response) { if (!response.ok) throw new Error('Add to cart failed'); return response.json(); })
          .then(function () { return refreshCart(true); })
          .catch(function () { window.location.href = form.getAttribute('action') || '/cart'; })
          .finally(function () { if (submitButton) { submitButton.disabled = false; submitButton.removeAttribute('aria-busy'); } updateVariant(); });
      });
    }
  });

  document.querySelectorAll('[data-bundle-target]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var targetId = link.getAttribute('data-bundle-target');
      var productSection = document.querySelector('[data-product-section]');
      if (!targetId || !productSection) return;
      var targetCard = Array.prototype.slice.call(productSection.querySelectorAll('[data-variant-card]')).find(function (card) {
        return card.getAttribute('data-variant-id') === targetId;
      });
      if (!targetCard) return;
      event.preventDefault();
      targetCard.click();
      var packs = productSection.querySelector('#packs');
      if (packs) packs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var primary = gallery.querySelector('.product-gallery__primary img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!primary || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var source = thumb.querySelector('img');
        if (!source) return;
        primary.src = source.src;
        primary.srcset = '';
        thumbs.forEach(function (item) { item.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}());
